import React from 'react';

export const THUMBNAIL_SIZE_TYPE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};

export const THUMBNAIL_PLACEHOLDER = '__THUMBNAIL_PLACEHOLDER__';

export const SHEET_UNTAGGED = '__UNTAGGED';

export const withProps = (Element, sheetContainerType) =>
  Object.assign(
    (props) => <Element {...props} sheetContainerType={sheetContainerType} />,
    {
      displayName: Element.displayName || Element.name || 'Component',
    },
  );

export const GET_SHEETS_RESPONSE_PLACEHOLDER = [{ id: '__PLACEHOLDER__' }];

export const COLLECTION_DIVIDER_KEY = Symbol('__DIVIDER_KEY__');

export const SEARCH_MODE = {
  CURRENT: 'CURRENT',
  ALL: 'ALL',
};
